/** @jsx jsx */
import { Component, type ComponentType, type ElementRef } from 'react';
import { cssMap, jsx } from '@compiled/react';
import noop from 'lodash/noop';
import ChevronDown from '@atlaskit/icon/utility/migration/chevron-down';
import { token } from '@atlaskit/tokens';
import { Item } from '../item/main.tsx';

const styles = cssMap({
	root: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Temporary workaround to make Emotion and Compiled specificity mesh until `@atlaskit/menu` is migrated to Compiled.
		'&&': {
			backgroundColor: token('color.background.input.pressed'),
			color: 'inherit',
			fontWeight: token('font.weight.medium'),
			paddingInlineEnd: token('space.050'),
			borderRadius: '3px',
			border: 0,
			outline: 'none',
			'&:focus': {
				boxShadow: `${token('elevation.shadow.raised')} 0px 0px 0px 2px inset`,
			},
			'&:hover': {
				backgroundColor: token('color.background.input'),
				color: 'inherit',
			},
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'[data-item-elem-before]': {
			color: 'inherit',
		},
	},
	isSelected: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Temporary workaround to make Emotion and Compiled specificity mesh until `@atlaskit/menu` is migrated to Compiled.
		'&&': {
			backgroundColor: token('color.background.input'),
			color: token('color.text.brand'),
			'&:hover': {
				color: token('color.text.brand'),
			},
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'[data-item-elem-before]': {
			color: token('color.text.brand'),
		},
	},
});

type Props = {
	isOpen: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Icon: ComponentType<any>;
	text: string;
	subText: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	targetRef: ElementRef<any> | undefined;
	onMouseEnter: () => void;
};

// @ts-expect-error - TS2769 - No overload matches this call.
const renderChevron = () => <ChevronDown spacing="spacious" />;

// eslint-disable-next-line jira/react/no-class-components
export default class Trigger extends Component<Props> {
	static defaultProps = {
		isOpen: false,
		Icon: () => null,
		subText: '',
		targetRef: null,
		onMouseEnter: noop,
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	renderComponent = (props: any) => (
		<button
			ref={props.targetRef}
			aria-expanded={this.props.isOpen}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={props.className}
			onMouseEnter={props.onMouseEnter}
			id="navigation-apps.scope-switcher-trigger-button"
		>
			{props.children}
		</button>
	);

	render() {
		const { isOpen, text, subText, onMouseEnter, targetRef } = this.props;

		return (
			<div>
				<Item
					component={this.renderComponent}
					text={text}
					subText={subText}
					before={this.props.Icon}
					after={renderChevron}
					// @ts-expect-error - TS2322 - Type '{ component: (props: any) => Element; text: string; subText: string; before: ComponentType<any>; after: () => Element; isSelected: boolean; styles: (state: any) => any; onMouseEnter: () => void; targetRef: unknown; }' is not assignable to type 'IntrinsicAttributes & ItemProps'.
					isSelected={isOpen}
					css={[styles.root, isOpen && styles.isSelected]}
					onMouseEnter={onMouseEnter}
					targetRef={targetRef}
				/>
			</div>
		);
	}
}
